import { t } from 'i18next'

import { DeliveryPeriodType as BffDeliveryPeriodType } from '@enechain/eposition-proto/bfftypes/v1/deal_pb'
import { DeliveryPeriodType } from '@enechain/eposition-proto/types/v1/deal_pb'

// bfftypes.v1 と types.v1 の DeliveryPeriodType は enum 値の並びが異なるため明示的に変換する
export function convertBffDeliveryPeriodType(
  value: BffDeliveryPeriodType,
): DeliveryPeriodType {
  switch (value) {
    case BffDeliveryPeriodType.MONTH:
      return DeliveryPeriodType.MONTH
    case BffDeliveryPeriodType.MULTI_MONTH:
      return DeliveryPeriodType.MULTI_MONTH
    case BffDeliveryPeriodType.QUARTER:
      return DeliveryPeriodType.QUARTER
    case BffDeliveryPeriodType.SEASON:
      return DeliveryPeriodType.SEASON
    case BffDeliveryPeriodType.FISCAL_YEAR:
      return DeliveryPeriodType.FISCAL_YEAR
    default:
      return DeliveryPeriodType.UNSPECIFIED
  }
}

export function convertDeliveryPeriodTypeLabel(
  value: DeliveryPeriodType,
): string {
  switch (value) {
    case DeliveryPeriodType.MONTH:
      return t('domain:shared.delivery_period_type.month')
    case DeliveryPeriodType.MULTI_MONTH:
      return t('domain:shared.delivery_period_type.months')
    case DeliveryPeriodType.QUARTER:
      return t('domain:shared.delivery_period_type.quarter')
    case DeliveryPeriodType.SEASON:
      return t('domain:shared.delivery_period_type.season')
    case DeliveryPeriodType.FISCAL_YEAR:
      return t('domain:shared.delivery_period_type.fiscal_year')
    default:
      return t('domain:shared.delivery_period_type.unspecified')
  }
}
